import { NON_CONFORMITY_CATEGORIES } from '@/lib/constants/nonConformities'
import { NON_CONFORMITY_STATUS } from '@/lib/constants/status'

export const NON_CONFORMITY_STATUS_LABELS = {
  [NON_CONFORMITY_STATUS.NOT_STARTED]: 'No Iniciado',
  [NON_CONFORMITY_STATUS.IN_PROGRESS]: 'En Proceso',
  [NON_CONFORMITY_STATUS.DELAYED]: 'Atrasado',
  [NON_CONFORMITY_STATUS.COMPLETED]: 'Completado',
}

export const NC_STATUS = {
  notStarted: 'No Iniciado',
  inProgress: 'En Proceso',
  delayed: 'Atrasado',
  completed: 'Completado',
}

export const NON_CONFORMITIES_TABLE = {
  CONTROL_CODE: 'Código de Control',
  TITLE: 'No Conformidades',
  STATUS: 'Estado',
  CODE: 'Código',
  CATEGORY: 'Categoría',
  ASSOCIATED_CONTROL: 'Control Asociado',
  NO_CONTROL: 'Sin Control',
  AUDIT_TYPE: 'Auditoría',
  YEAR: 'Año',
}

export const NON_CONFORMITY_CATEGORIES_LABELS = {
  [NON_CONFORMITY_CATEGORIES.MAJOR]: 'Mayor',
  [NON_CONFORMITY_CATEGORIES.MINOR]: 'Menor',
  [NON_CONFORMITY_CATEGORIES.OBSERVATION]: 'Observación',
  [NON_CONFORMITY_CATEGORIES.OPPORTUNITY]: 'Oportunidad de Mejora',
}

export const NC_CATEGORIES = {
  MAJOR: 'Mayor',
  MINOR: 'Menor',
  OBSERVATION: 'Observación',
  OPPORTUNITY: 'Oportunidad',
}

export const NC_HEADER = {
  TITLE: 'No Conformidades',
  SEARCH_PLACEHOLDER: 'Buscar no conformidades...',
  BULK_UPLOAD: 'Carga masiva',
  EXPORT: 'Exportar CSV',
  EXPORT_EMPTY: 'No hay no conformidades que exportar con los filtros actuales.',
}

export const NC_FILTERS = {
  FILTER_BY_CATEGORY: 'Filtrar por Categoría',
  FILTER_BY_STATUS: 'Filtrar por Estado',
  FILTER_BY_CONTROL: 'Filtrar por Control',
  FILTER_BY_YEAR: 'Filtrar por Año',
  CATEGORY: 'Categoría',
  YEAR: 'Año',
  CLEAR_FILTERS: 'Limpiar filtros',
}

export const NC_CREATION_DIALOG = {
  TITLE: 'Nueva No Conformidad',
  NAME: 'Nombre',
  DESCRIPTION: 'Description',
  CREATE: 'Create',
}
export const NON_CONFORMITY_MESSAGES = {
  UPDATE_SUCCESS: 'No-conformidad actualizada correctamente',
  UPDATE_ERROR: 'Error al actualizar la no-conformidad',
  FETCH_ERROR: 'Error al obtener la no-conformidad',
  DELETE_SUCCESS: 'No-conformidad eliminada correctamente',
  DELETE_ERROR: 'Error al eliminar la no-conformidad',
  CREATE_SUCCESS: 'No-conformidad creada correctamente',
  DELETE_QUESTION: '¿Estás seguro de querer eliminar esta no-conformidad?',
  DELETE_DIALOG: {
    TITLE: 'Eliminar No-Conformidad',
    QUESTION: '¿Estás seguro de querer eliminar esta no-conformidad?',
  },
}

export const NC_DELETE_DIALOG = {
  TITLE: 'Eliminar No-Conformidad',
  QUESTION: '¿Estás seguro de querer eliminar',
  CONFIRMATION: 'Esta acción no se puede deshacer.',
  CANCEL: 'Cancelar',
  DELETE: 'Eliminar',
}

export const NON_CONFORMITY_DRAWER = {
  EFFECTIVENESS: 'Revisión de Efectividad',
  LONG_TERM_ACTION: 'Acción a Largo Plazo',
  SHORT_TERM_ACTION: 'Acción a Corto Plazo',
  ROOT_CAUSE: 'Causa Raíz',
  EVIDENCE: 'Evidencia',
  DESCRIPTION: 'Descripción',
  NO_DESCRIPTION: 'No hay descripción disponible',
  DESCRIPTION_PLACEHOLDER: 'Sin descripción',
  SHORT_TERM_ACTION_PLACEHOLDER: 'Escribe la acción a corto plazo...',
  LONG_TERM_ACTION_PLACEHOLDER: 'Escribe la acción a largo plazo...',
  ATTRIBUTES: 'Atributos',
  CODE: 'Código',
  YEAR: 'Año',
  CATEGORY: 'Categoría',
  AUDIT_TYPE: 'Tipo de Auditoría',
  ASSOCIATED_CONTROL: 'Control Asociado',
  ROOT_CAUSE_PLACEHOLDER: 'No se identificó causa raíz',
  CORRECTIVE_ACTIONS: 'Acciones Correctivas',
  SHORT_TERM: 'Corto Plazo',
  LONG_TERM: 'Largo Plazo',
  NO_SHORT_TERM_ACTION: 'Sin acción a corto plazo',
  NO_LONG_TERM_ACTION: 'Sin acción a largo plazo',
  RESPONSIBLE: 'Responsable',
  DATE: 'Fecha',
  NO_OWNER: 'Sin responsable',
  NO_DATE: 'Sin fecha',
  NO_CONTROL: 'Sin Control',
  RATING: 'Calificación',
  NOTES: 'Notas',
  NOTES_PLACEHOLDER: 'Añade notas sobre la evaluación de efectividad...',
  NO_NOTES: 'Sin notas',
}

export const NON_CONFORMITY_DIALOG = {
  CODE: 'Código',
  CATEGORY: 'Categoría',
  DESCRIPTION: 'Descripción',
  ROOT_CAUSE: 'Causa Raíz',
  CREATE: 'Crear No-Conformidad',
  ERROR_MESSAGE: 'Por favor, complete todos los campos requeridos',
}

export const NC_TYPE_FILTER = {
  ALL: 'Todos',
  INTERNAL: 'Interna',
  EXTERNAL: 'Externa',
}

export const NC_BULK_UPLOAD_DIALOG = {
  TITLE: 'Importar No Conformidades desde CSV',
  DESCRIPTION:
    'Sube un archivo CSV para importar no conformidades de forma masiva. Todas las filas deben ser válidas — cualquier error se mostrará a continuación y no se creará nada hasta que los corrijas.',
  UPLOAD_FILE: 'Subir CSV',
  UPLOADING: 'Subiendo...',
  CREATING: 'Creando no conformidades...',
  SUCCESS: 'No conformidades importadas correctamente',
  CANCEL: 'Cancelar',
  VALIDATION_TABLE_ROW: 'Fila',
  VALIDATION_TABLE_FIELD: 'Campo',
  VALIDATION_TABLE_ERROR: 'Error',
  VALIDATION_TABLE_RECEIVED_VALUE: 'Valor recibido',
  DOWNLOAD_SAMPLE: 'Descargar CSV de ejemplo',
  HEADER_ERROR_TITLE: 'La cabecera de tu CSV tiene problemas',
  HEADER_ERROR_DESCRIPTION:
    'Corrige la fila de cabecera en tu archivo y vuelve a subirlo. Las columnas aceptadas se muestran a continuación.',
  ACCEPTED_COLUMNS_REQUIRED: 'Columnas obligatorias',
  ACCEPTED_COLUMNS_OPTIONAL: 'Columnas opcionales',
  SUMMARY_LINE:
    '{totalRows} filas revisadas, {errorCount} errores encontrados. Corrígelos en tu CSV y vuelve a subirlo.',
  ERROR_UNKNOWN_COLUMN: 'Columna desconocida: {field}',
  ERROR_MISSING_REQUIRED_COLUMN: 'Falta la columna obligatoria: {field}',
  ERROR_MALFORMED_ROW: 'Fila mal formada',
  ERROR_REQUIRED: '{field} es obligatorio',
  ERROR_DUPLICATE_IN_FILE: 'Nombre duplicado en este archivo: "{receivedValue}"',
  ERROR_DUPLICATE_IN_DB: 'Ya existe una no conformidad con este nombre: "{receivedValue}"',
  ERROR_INVALID_CATEGORY: 'Categoría no válida "{receivedValue}". Valores permitidos: {allowedValues}',
  ERROR_INVALID_STATUS: 'Estado no válido "{receivedValue}". Valores permitidos: {allowedValues}',
  ERROR_INVALID_AUDIT_TYPE: 'Tipo de auditoría no válido "{receivedValue}". Valores permitidos: {allowedValues}',
  ERROR_INVALID_INTEGER_RANGE:
    '{field} debe ser un número entero dentro del rango permitido. Recibido: "{receivedValue}"',
  ERROR_INVALID_LENGTH: '{field} es demasiado largo. Recibido: "{receivedValue}"',
  ERROR_INVALID_DATE: 'Fecha no válida en {field}. Recibido: "{receivedValue}"',
  ERROR_OWNER_NOT_FOUND: 'Usuario no encontrado en esta organización: "{receivedValue}"',
  ERROR_CONTROL_NOT_FOUND: 'Control no encontrado en esta organización: "{receivedValue}"',
  ERROR_INVALID_EVIDENCE_FORMAT: 'Formato de evidencia no válido. Se esperaba "Etiqueta|URL"',
  ERROR_OPERATIONAL_ERROR: 'No se pueden crear las no conformidades en este momento. Inténtalo de nuevo.',
}
